var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","color":"#c00000","border-radius":"14px","margin":"10px 0 0 0","justify-content":"center","align-items":"center"}},[_c('div',[_vm._v("Results for the 2018-2026 Time-window will be Provided once 2026 Data is Fully Available ")])])
}]

export { render, staticRenderFns }